import { Component, OnInit } from '@angular/core';

import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
    selector: 'app-partner-program',
    imports: [],
    templateUrl: './partner-program.component.html',
    styleUrls: ['./partner-program.component.css']
})
export class PartnerProgramComponent implements OnInit {
  contactForm = new FormGroup({
    name: new FormControl('', Validators.required),
    email: new FormControl('', [Validators.required, Validators.email]),
    company: new FormControl(''),
    message: new FormControl('', Validators.required)
  });

  isSubmitting = false;
  submitted = false;

  constructor() { }

  ngOnInit(): void {
  }

  onSubmit(): void {
    if (!this.contactForm.valid) {
      this.contactForm.markAllAsTouched();
      return;
    }

    this.isSubmitting = true;
    setTimeout(() => {
      this.isSubmitting = false;
      this.submitted = true;
      this.contactForm.reset();
      setTimeout(() => {
        this.submitted = false;
      }, 5000);
    }, 1500);
  }

}
